import * as R from 'ramda';
import RadioGroup from '../../../../uikit/buttons/RadioGroup';
import React from 'react';

const TakeChargeCheckbox = ({
  takeChargeOfBeneficiaries,
  setTakeChargeOfBeneficiaries,
  tariffStructures,
  tariffStructureIsUniform,
  setTariffStructureIsUniform
}) => {
  const hasTariffStructure = tariffStructure => R.includes(tariffStructure, tariffStructures);

  return <div
    className="flex justify-between"
  >
    <div
      className="grid grid-cols-[repeat(2,minmax(0,1fr))] gap-x-4 gap-y-4 items-center"
      style={{
        marginTop: '40px',
        width: '550px'
      }}>

      <div className="uppercase text-end font-bold">
        Souhaitez-vous prendre en charge les ayants droits *
      </div>

      <RadioGroup
        options={[
          { label: 'Oui', value: 'true' },
          { label: 'Non', value: 'false' }
        ]}
        name="takeChargeOfBeneficiaries"
        style={{ justifyContent: 'center' }}
        value={JSON.stringify(takeChargeOfBeneficiaries)}
        onChange={R.isEmpty(tariffStructures) ? null : v => setTakeChargeOfBeneficiaries(JSON.parse(v))}
      />

      {hasTariffStructure('UNIFORME') && takeChargeOfBeneficiaries && <>
        <div className="uppercase text-end font-bold">
          Régime Uniforme
        </div>

        <RadioGroup
          options={[
            { label: 'Oui', value: 'true' },
            { label: 'Non', value: 'false' }
          ]}
          name="tariffStructureIsUniform"
          style={{ justifyContent: 'center' }}
          value={JSON.stringify(tariffStructureIsUniform)}
          onChange={v => setTariffStructureIsUniform(JSON.parse(v))}
        />
      </>}
    </div>
  </div>;
};

export default TakeChargeCheckbox;
